import api from '../../../api';
// Get all modules for CRUD management (used by ModulesManagement component)
export const getModulesForCrud = async () => {
  try {
    const response = await api.get('/permissions/modules-crud');
    return response.data;
  } catch (error) {
    throw error;
  }
};
// Create new module
export const createModule = async (moduleData) => {
  try {
    const response = await api.post('/permissions/modules', moduleData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
// Update module
export const updateModule = async (moduleId, moduleData) => {
  try {
    const response = await api.put(`/permissions/modules/${moduleId}`, moduleData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
// Delete module
export const deleteModule = async (moduleId) => {
  try {
    const response = await api.delete(`/permissions/modules/${moduleId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
